import { useRouter } from 'next/router';
import { useEffect, useState, useRef } from 'react';
export function useMidTermQuery(product, debounceDelay = 300) {
  // FOR LONG TERM
  // const router = useRouter()
  // const { query } = router
  // const is_mid_term = product?.is_mid_term || false
  // const [isMidTerm, setIsMidTerm] = useState(
  //   is_mid_term && query.mid_term === '1',
  // )
  // const debounceTimeout = useRef<number | undefined>(undefined)
  //
  // useEffect(() => {
  //   if (is_mid_term) {
  //     setIsMidTerm(query.mid_term === '1')
  //   }
  // }, [query?.mid_term, is_mid_term])
  //
  // const toggleMidTerm = (options = { shallow: true }) => {
  //   if (debounceTimeout.current !== undefined) {
  //     clearTimeout(debounceTimeout.current)
  //   }
  //
  //   const newQuery = { ...query }
  //   if (is_mid_term) {
  //     if (isMidTerm) {
  //       delete newQuery.mid_term
  //     } else {
  //       newQuery.mid_term = '1'
  //     }
  //   }
  //
  //   debounceTimeout.current = window.setTimeout(() => {
  //     if (is_mid_term) {
  //       setIsMidTerm(!isMidTerm)
  //       router.push(
  //         { pathname: router.pathname, query: newQuery },
  //         `/houses/show/${router.query.id}`,
  //         options,
  //       )
  //     }
  //   }, debounceDelay)
  // }
  return {
    isMidTerm: false,
    toggleMidTerm: () => {}
  };
}